var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[(!_vm.supportRoutes.includes(_vm.currentRouteName))?[_c('div',{staticClass:"support-helper-btn"},[_c('span',{staticClass:"support-text"},[_vm._v(_vm._s(_vm.$t("components.footer.techSupport")))])]),_c('dialogFlowCX')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }